/**
 * Reading a beta feature's state.
 *
 * Two accessors, because the gates live on two kinds of surface:
 *  - `useBetaFeature` for React components, so flipping a checkbox in Settings
 *    repaints the toolbar / menu immediately.
 *  - `isBetaFeatureEnabled` for the pure models and registries that run outside
 *    React (`CommandDefinition.isVisible`, keyboard handlers, context-menu
 *    builders). These are all re-evaluated at the moment the surface opens, so
 *    a snapshot read is correct there and a hook is not available anyway.
 */
import { useAppStore } from '../../store/appStore';
import { resolveBetaFeature, type BetaFeatureId } from './betaFeatures';

/** Snapshot read. Use inside `isVisible` / event handlers / builders. */
export function isBetaFeatureEnabled(id: BetaFeatureId): boolean {
  return resolveBetaFeature(useAppStore.getState().betaFeatures, id);
}

/** Subscribed read. Use inside components. */
export function useBetaFeature(id: BetaFeatureId): boolean {
  return useAppStore((state) => resolveBetaFeature(state.betaFeatures, id));
}
